<template>
  <f-form
    store="@freebe/entrepreneurs"
    :id="entrepreneur._id"
  >
    <template #default="{ item }">
      <div class="is-grid">
        <f-field 
          class="is-col-6"
          label="Email"
        >
          <f-input 
            v-model="item.email"
            suffix-icon="envelope"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Nom complet"
        >
          <f-input 
            v-model="item.name"
            suffix-icon="user"
          ></f-input>
        </f-field>


        <f-field 
          class="is-col-3"
          label="Prénom"
        >
          <f-input 
            v-model="item.firstname"
            suffix-icon="user"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Nom"
        >
          <f-input 
            v-model="item.lastname"
            suffix-icon="user"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Date de création"
        >
          <f-datepicker 
            v-model="item.creation.date"
          ></f-datepicker>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Date entreprise"
        >
          <f-datepicker 
            v-model="item.creation.institution"
          ></f-datepicker>
        </f-field>

        <f-field 
          class="is-col-3"
          label="N° SIRET"
        >
          <f-input 
            v-model="item.siret"
            suffix-icon="user"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="N° SIREN"
        >
          <f-input 
            v-model="item.siren"
            suffix-icon="user"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="N° NIC"
        >
          <f-input 
            v-model="item.nic"
            suffix-icon="user"
          ></f-input>
        </f-field>

        <div class="is-col-12">
          <hr>
        </div>

        <b-search-address 
          class="is-col-6"
          v-model="item.address"
        >
        </b-search-address>

        <f-field 
          class="is-col-6"
          label="Nom commercial"
        >
          <f-input 
            v-model="item.commercial_name"
            suffix-icon="pricetag-alt"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Téléphone"
        >
          <f-input 
            v-model="item.phone"
            suffix-icon="phone"
          ></f-input>
        </f-field>

        <f-field 
          class="is-col-3"
          label="Site web"
        >
          <f-input 
            v-model="item.website"
            suffix-icon="globe"
          ></f-input>
        </f-field>
      </div>
    </template>
  </f-form>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import { useDate, formatDate } from '@composables/use-date'

  export default {
    setup () {
      const { get, fetch, patch, remove } = useStore('@freebe/entrepreneurs')

      const entrepreneurId = computed(() => 
        router.currentRoute.value.params.entrepreneur_id
      )
      const entrepreneur = computed(() => get(entrepreneurId.value))

      return {
        entrepreneur,
      }
    } 
  }
</script>